export default __webpack_public_path__ + "static/media/ElitePairingStudioIconOrange.bd2de3ca.svg";